'use strict';
import axios from 'axios';
import ENV from '../environtment'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

// Nitip heula didieu, ke di pindahkeun ka fiturna masing2 
// user ka user, group ka group
const actions = {
  getAuditTrailDownload(context, params = '') {
    const defaultData = { rows: [], count: 0 }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/audittrail/downloads`
        window.open(`${url}${params}`)
        return resolve(defaultData)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        return resolve(defaultData)
      }
    })
  },
  getAuditTrail(context, params = {}) {
    const defaultData = { rows: [], count: 0 }
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/audittrail/findbydate`
        const result = await axios.get(url, {
          ...costumHeader('Get Audit Trail', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        return resolve(defaultData)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        return resolve(defaultData)
      }
    })
  },
  getNumberMaskFormat(context, separator = true) {
    return createNumberMask({
      prefix: '',
      allowDecimal: false,
      includeThousandsSeparator: separator,
      allowNegative: true,
    })
  },
  saveSummaryPayroll(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payroll_reports`
        const result = await axios.get(url, {
          ...costumHeader('Save Period', 1),
          params
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  getAddressMaps(context, params = {}) {
    return new Promise(async (resolve) => {
      const defaultData = { results: []}
      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json`
        const result = await axios.get(url, { params })
        if (result) return resolve(result.data)
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getSummaryPayroll(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payroll_process_logs`
        const result = await axios.get(url, {
          ...costumHeader('Get Payroll Summary', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve({})
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve({})
      }
    })
  },
  getSummaryPayrollDownload(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/download_payroll_report`
        const result = await axios.get(url, {
          ...costumHeader('Get Payroll Summary Download', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve('')
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve('')
      }
    })
  },
  getPreserveWord(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/reservedwords`
        const result = await axios.get(url, {
          ...costumHeader('Get preserve Word', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getUserByCompanyId(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollusers`
        const result = await axios.get(url, {
          ...costumHeader('Get User Payroll Per Period', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getTax(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/taxparameters`
        const result = await axios.get(url, {
          ...costumHeader('Get Tax Parameter', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getPayrollComponentType(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/componenttypes`
        const result = await axios.get(url, {
          ...costumHeader('Get Component Type', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getHolidayByCompany(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/holiday/findbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Holiday by company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  savePayrollUsers(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payroll_temp_employees`
        const result = await axios.post(url, body, costumHeader('Save Payroll User', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editSortingComponent(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollcomponents/sequence`
        const result = await axios.put(url, body, costumHeader('Edit Payroll Sequence', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  savePayrollProcess(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payrollprocess`
        const result = await axios.post(url, body, costumHeader('Save Payroll Process', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  getCompanyDetail(context, param) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/companies/${param}`
        const result = await axios.get(url, {
          ...costumHeader('Get Company Detail', 4),
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  editCompanyDetail(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/companies/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Company Detail', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  updatePicEmail(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v3/company/changePIC`;
        const result = await axios.put(url, body, costumHeader('Update PIC Email', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }